var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6V12C21 13.0609 20.5575 14.0783 19.7698 14.8284C18.9822 15.5786 17.9139 16 16.8 16H4.2C3.08609 16 2.0178 15.5786 1.23015 14.8284C0.442499 14.0783 0 13.0609 0 12V6H21ZM5.2605 10H5.25C5.11211 10.0007 4.97571 10.0272 4.84858 10.078C4.72145 10.1289 4.60609 10.2031 4.50908 10.2964C4.31315 10.4849 4.20386 10.7398 4.20525 11.005C4.20594 11.1363 4.23378 11.2662 4.28719 11.3873C4.34059 11.5084 4.41851 11.6182 4.5165 11.7106C4.61449 11.803 4.73063 11.8761 4.85828 11.9258C4.98594 11.9754 5.12261 12.0007 5.2605 12C5.53898 12 5.80605 11.8946 6.00296 11.7071C6.19987 11.5196 6.3105 11.2652 6.3105 11C6.3105 10.7348 6.19987 10.4804 6.00296 10.2929C5.80605 10.1054 5.53898 10 5.2605 10ZM11.55 10H9.45C9.17152 10 8.90445 10.1054 8.70754 10.2929C8.51062 10.4804 8.4 10.7348 8.4 11C8.4 11.2652 8.51062 11.5196 8.70754 11.7071C8.90445 11.8946 9.17152 12 9.45 12H11.55C11.8285 12 12.0955 11.8946 12.2925 11.7071C12.4894 11.5196 12.6 11.2652 12.6 11C12.6 10.7348 12.4894 10.4804 12.2925 10.2929C12.0955 10.1054 11.8285 10 11.55 10ZM16.8 0C17.9139 0 18.9822 0.421427 19.7698 1.17157C20.5575 1.92172 21 2.93913 21 4H0C0 2.93913 0.442499 1.92172 1.23015 1.17157C2.0178 0.421427 3.08609 0 4.2 0H16.8Z",
    fill: "#B9BDCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.87a093b9fd47d93bdddda3a82c6c99af.svg";
export { ForwardRef as ReactComponent };